import { memo } from "react";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { CountryInput } from "./CountryInput";
import { Stack } from "@mui/material";

interface ExcludedCountriesSectionProps {
  selectedItems: string[];
  onCountrySelect: (countries: string[]) => void;
}

export const ExcludedCountriesSection = memo(
  ({ selectedItems, onCountrySelect }: ExcludedCountriesSectionProps) => {
    return (
      <>
        <Stack direction="column" spacing={1}>
          <Divider />
          <Typography variant="subtitle2">
            Exclude the following countries
          </Typography>

          <CountryInput
            selectedItems={selectedItems || []}
            onCountrySelect={onCountrySelect}
          />
        </Stack>
      </>
    );
  }
);

ExcludedCountriesSection.displayName = "ExcludedCountriesSection";
